module.exports = __webpack_public_path__ + "img/cp6_02.8479aae8.jpg";